"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AES_CBC = void 0;
const algoTypes_1 = require("./algoTypes");
class AES_CBC {
    algo;
    type = algoTypes_1.AlgoTypes.aes_cbc;
    iv;
    derivation;
    encrypt;
    decrypt;
}
exports.AES_CBC = AES_CBC;
//# sourceMappingURL=aes_cbc.js.map